var map = {
	"./pexels-brayden-law-1738986.jpg": 722,
	"./pexels-gdtography-911758.jpg": 349,
	"./pexels-matheus-natan-3297593.jpg": 0,
	"./pexels-scott-webb-532568.jpg": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 820;